import { Injectable } from '@angular/core';
import { MacroFlowMapping, SalesWorkflowMacro } from "projects/store/src/app/enums";


@Injectable({
  providedIn: 'root'
})
export class MacroFlowService {

  constructor() { }


  private getMacroFlowByFlow(flowCode: string): string | undefined {
    for (const [macroFlow, flows] of Object.entries(MacroFlowMapping)) {
      if (flows.includes(flowCode)) {
        return macroFlow;
      }
    }
    return undefined;
  }

  private getFlowsByMacroFlow(macroFlow: string): string[] {
    return MacroFlowMapping[macroFlow] || [];
  }

  public getAutogestionTiendaFlow(): string {
    const flows = this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-autogestion-cliente']);
    return flows[2];
  }

  public getAutogestionClienteFlow(): string {
    const flows = this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-autogestion-cliente']);
    return flows[1];
  }

  public getGeneralFlow(): string {
    const flows = this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-autogestion-cliente']);
    return flows[0];
  }

  public getGeneralTiendaFlow(): string {
    const flows = this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-gestion-cliente']);
    return flows[0];
  }

  public getGestionTiendaFlow(): string {
    const flows = this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-gestion-cliente']);
    return flows[1];
  }

  public getKredicashClienteFlow(): string {
    const flows = this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-kredicash-cliente']);
    return flows[0];
  }

  public getAddressClientFlow(): string {
    const flows = this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-venta-domicilio']);
    return flows[0];
  }

  public getAddressSalesFlow(): string {
    const flows = this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-venta-domicilio']);
    return flows[1];
  }

  public getKredicashExpressFlow(): string {
    const flows = this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-kredicash-express']);
    return flows[0];
  }

  public getGeneralExperanzaFlow(): string {
    const flows = this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-experanza']);
    return flows[0];
  }

  public getGestionTiendaExperanzaFlow(): string {
    const flows = this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-experanza']);
    return flows[1];
  }

  getNextFlowInMacro(currentFlow: string): string | undefined {
    const macroFlow = this.getMacroFlowByFlow(currentFlow);
    if (!macroFlow) return undefined;

    const flows = this.getFlowsByMacroFlow(macroFlow);
    const currentIndex = flows.indexOf(currentFlow);

    if (currentIndex === -1) {
      return undefined;
    }

    if (currentIndex === flows.length - 1) {
      return flows[flows.length - 1];
    }

    return flows[currentIndex + 1];
  }

  getPreviousFlowInMacro(currentFlow: string): string | undefined {
    const macroFlow = this.getMacroFlowByFlow(currentFlow);
    if (!macroFlow) return undefined;

    const flows = this.getFlowsByMacroFlow(macroFlow);
    const currentIndex = flows.indexOf(currentFlow);

    if (currentIndex === -1) {
      return undefined;
    }

    if (currentIndex === 0) {
      return flows[0];
    }

    return flows[currentIndex - 1];
  }

  getFirstFlowInMacro(currentFlow: string): string | undefined {
    const macroFlow = this.getMacroFlowByFlow(currentFlow);
    if (!macroFlow) return undefined;

    const flows = this.getFlowsByMacroFlow(macroFlow);

    if (flows.length === 0) {
      return undefined;
    }

    return flows[0];
  }

  getFlowByPositionInMacro(macroFlow: string, position: number): string | undefined {
    const flows = this.getFlowsByMacroFlow(macroFlow);

    if (flows.length === 0) {
      return undefined;
    }

    if (position < 0 || position >= flows.length) {
      return undefined;
    }

    return flows[position];
  }

  isExperanzaFlow(flowCode: string) {
    return this.getFlowsByMacroFlow(SalesWorkflowMacro['macro-experanza']).includes(flowCode);
  }
}
